import { DICT_KEY } from "@/constants/dict";
import { queryDictList } from "@/api/dict";
import { onMounted, reactive } from "vue";
export default function useDict() {
  const result = reactive({});

  const initDict = () => {
    Object.entries(DICT_KEY).forEach((item) => {
      queryDictList(item[1]).then((res) => {
        result[item[0]] = res.data || [];
      });
    });
  };

  onMounted(() => {
    initDict();
  });

  return {
    result,
  };
}
